import React, { useState } from 'react';
import { Stack, Button, Typography, Box } from '@mui/material';
import { EditableDetailBox, StyledDetailBox } from '../Card/DetailBox';
import { useTheme } from '@mui/system';
import ImageModal from '../SuperSettings/ImageReview/ImageModal';

function ItemImageBox(props) {
    const theme = useTheme();
    const [modalOpen, setModalOpen] = useState(false);

    const handleDeleteClick = async() => {
        await props.deleteItemImage({
            image: props.image,
            itemId: props.item.id,

        });
    }

    async function handleValidateClick() {
        await props.validateItemImage({
            imageId: props.image.id,
            itemId: props.item.id,
            isManuallyValidated: true,
        });
    }

    const handleImageClick = () => {
        if (props.canEdit) {
            setModalOpen(true);
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    return (
        <Stack sx={{ maxWidth: 'min(400px, 66.67vw)' }}>
            { props.canEdit && 
                <EditableDetailBox p={2}>
                    <Stack spacing={1}>
                        <Typography variant='normal' sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}` }}>{props.image.name}</Typography>
                        <Box
                            component="img"
                            src={props.image.presigned_url}
                            width="100%"
                            sx={{ 
                                objectFit: 'contain',
                                cursor: 'pointer',
                                '&:hover': { opacity: 0.8 },
                                transition: 'opacity 0.2s ease'
                            }}
                            alt="item"
                            onClick={handleImageClick}
                        />
                        <Stack direction='row' spacing={2} justifyContent='end' alignItems='center'>
                            <Button variant='text' onClick={handleDeleteClick} color='error'>Delete</Button>
                            { props.image.is_manually_validated ?
                                <Button variant='contained' disabled style={{ color: `${theme.palette.subtext.main}` }}>Validated</Button> : 
                                <Button variant='contained' onClick={handleValidateClick} style={{ backgroundColor: `${theme.palette.green.main}`, color: 'white' }}>Validate</Button>
                            }
                        </Stack>
                    </Stack>
                </EditableDetailBox>
            }
            { !props.canEdit && 
                <StyledDetailBox p={2}>
                    <Stack spacing={1}>
                        <Typography variant='normal' sx={{ fontSize: '12px', color: `${theme.palette.subtext.main}` }}>Image</Typography>
                        <img src={props.image.presigned_url} width='100%' style={{ objectFit: 'contain' }} alt='item'/>
                    </Stack>
                </StyledDetailBox>
            }
            { props.canEdit && 
                <ImageModal
                    open={modalOpen}
                    onClose={handleModalClose}
                    image={props.image}
                />
            }
        </Stack>
    );
}

export default ItemImageBox;
